import React from 'react';

export default ({ name, url, allow = 'payment;' }) => {
  if (!url) {
    return null;
  }
  return (
    <iframe name={name} src={url} height='700' width='100%' style={{ border: 0 }} allow={allow} />
  );
};
